import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import SignIn from "./modules/signIn";
import ResetPassword from "./modules/resetPassword";
import SignUp from "./modules/signUp";
import SetupConsentPolicy from "./modules/setupConsentPolicy";
import Header from "./common/components/header";
import Consent from "./modules/consent";
import { hideHeaderPaths, path } from "./constants";
import { useSelector } from "react-redux";
import { CommonLoader } from "./common/components/loader";
import EmaiVerification from "./modules/emailVerification";
const Router = () => {
  const location = useLocation();
  let isLoading = useSelector((state) => state.user.loading);
  return (
    <div className="w-full">
      {isLoading && <CommonLoader />}
      {!hideHeaderPaths.includes(location.pathname) ? <Header /> : ""}
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/consent/*" element={<Consent />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/setup-consent" element={<SetupConsentPolicy />} />
        <Route path={path.EMAIL_VERIFICATION} element={<EmaiVerification />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

export default Router;
